import api from './api';
import type {
  Invoice,
  InvoiceFilters,
  InvoiceResponse,
  CreateInvoiceRequest,
  UpdateInvoiceRequest,
  AutoInvoiceItemsResponse
} from '../types/invoice';

export const invoiceService = {
  // Get all invoices with pagination and filters
  getInvoices: async (filters?: InvoiceFilters): Promise<InvoiceResponse> => {
    const params = new URLSearchParams();

    if (filters?.page) params.append('page', filters.page.toString());
    if (filters?.limit) params.append('limit', filters.limit.toString());
    if (filters?.search) params.append('search', filters.search);
    if (filters?.log_sheet_id) params.append('log_sheet_id', filters.log_sheet_id.toString());
    if (filters?.is_cancelled) params.append('is_cancelled', filters.is_cancelled);
    if (filters?.sort_by) params.append('sort_by', filters.sort_by);
    if (filters?.sort_order) params.append('sort_order', filters.sort_order);

    const response = await api.get(`/invoices?${params.toString()}`);
    return response.data;
  },

  // Get single invoice by ID
  getInvoiceById: async (id: number): Promise<Invoice> => {
    const response = await api.get(`/invoices/${id}`);
    return response.data;
  },

  // Get auto-generated items for a log sheet
  getAutoGeneratedItems: async (logSheetId: number): Promise<AutoInvoiceItemsResponse> => {
    const response = await api.get(`/invoices/auto-items/${logSheetId}`);
    return response.data;
  },

  // Create new invoice
  createInvoice: async (data: CreateInvoiceRequest): Promise<Invoice> => {
    const response = await api.post('/invoices', data);
    return response.data;
  },

  // Update existing invoice
  updateInvoice: async (id: number, data: UpdateInvoiceRequest): Promise<Invoice> => {
    const response = await api.put(`/invoices/${id}`, data);
    return response.data;
  },

  // Delete invoice
  deleteInvoice: async (id: number): Promise<void> => {
    await api.delete(`/invoices/${id}`);
  },

  // Cancel invoice
  cancelInvoice: async (id: number): Promise<Invoice> => {
    const response = await api.patch(`/invoices/${id}/cancel`);
    return response.data;
  },

  // Share invoice via WhatsApp
  shareInvoice: async (id: number): Promise<{ success: boolean; message: string }> => {
    const response = await api.post(`/invoices/${id}/share`);
    return response.data;
  }
};